/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ClientAnalysisReferenceState = (typeof ClientAnalysisReferenceState)[keyof typeof ClientAnalysisReferenceState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientAnalysisReferenceState = {
  in_progress: "in_progress",
  completed: "completed",
  declined: "declined",
} as const;
